// Продление токена Keycloak по событиям, а не только по таймеру.
//
// Фоновый setInterval в App.js браузер троттлит в скрытой вкладке и не гоняет,
// пока машина спит: человек возвращается к открытой вкладке, и первый же запрос
// уходит с протухшим access-токеном — «Invalid token: Signature has expired»
// (docs/CHANGELOG.md, 10.10.2026). Здесь три дополнительных повода
// продлить: вкладка снова видна, окно получило фокус, сам Keycloak сообщил об
// истечении. Перед каждым запросом токен продлевает services/freshAuth.js.
//
// Сбой продления — ещё не повод выходить. Без сети (обрыв Wi-Fi посреди живой
// записи) updateToken падает, а выход размонтирует экран записи вместе с буфером
// звука. Выходим, только когда протух сам refresh-токен: keycloak-js на отказе
// сервера (400) и так стирает его (clearToken), а на сетевой ошибке — оставляет,
// и тогда пробуем снова на следующем тике или событии.
const MIN_VALIDITY_SEC = 70;
const INTERVAL_MS = 60000;

/** Жив ли refresh-токен: пока да, неудачное продление — временная беда сети. */
export function refreshTokenAlive(keycloak, now = Date.now()) {
  const exp = keycloak?.refreshTokenParsed?.exp;
  return Number.isFinite(exp) && exp * 1000 > now;
}

export function installKeycloakRefresh(keycloak, onFail, { intervalMs = INTERVAL_MS } = {}) {
  let failed = false;
  const refresh = () => {
    if (failed) return;
    keycloak.updateToken(MIN_VALIDITY_SEC).catch(() => {
      if (refreshTokenAlive(keycloak)) return;  // сеть вернётся — продлим на следующем поводе
      if (!failed) { failed = true; onFail(); }
    });
  };
  const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('focus', refresh);
  keycloak.onTokenExpired = refresh;
  // Фоновое продление: раз в минуту, если жить осталось < MIN_VALIDITY_SEC.
  const timer = setInterval(refresh, intervalMs);
  return () => {
    clearInterval(timer);
    document.removeEventListener('visibilitychange', onVisible);
    window.removeEventListener('focus', refresh);
    if (keycloak.onTokenExpired === refresh) keycloak.onTokenExpired = undefined;
  };
}
